import React, { useState } from 'react';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const TMBCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [weight, setWeight] = useState('70');
  const [height, setHeight] = useState('170');
  const [age, setAge] = useState('30');
  const [gender, setGender] = useState('male');
  const [activity, setActivity] = useState('moderate');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    const w = parseFloat(parseBrazilianNumber(weight)) || 0;
    const h = parseFloat(parseBrazilianNumber(height)) || 0;
    const a = parseInt(age) || 0;
    if (w <= 0 || h <= 0 || a <= 0) return;

    let tmb = gender === 'male'
      ? 88.362 + (13.397 * w) + (4.799 * h) - (5.677 * a)
      : 447.593 + (9.247 * w) + (3.098 * h) - (4.330 * a);

    const factors = { sedentary: 1.2, light: 1.375, moderate: 1.55, active: 1.725, very_active: 1.9 };
    const daily = tmb * (factors[activity as keyof typeof factors] || 1.55);

    setRes({ tmb: Math.round(tmb), daily: Math.round(daily) });
    onResultChange([
      { label: 'TMB', value: `${Math.round(tmb)} kcal` },
      { label: 'Calorias Diárias', value: `${Math.round(daily)} kcal` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-6 rounded-2xl border border-theme-border text-center font-black text-theme-text uppercase tracking-widest">
        Taxa Metabólica Basal
      </div>
      <div className="bg-theme-result p-8 rounded-3xl border border-theme-border shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <FormField label="Peso (kg)" value={weight} onChange={setWeight} isNumeric required type="text" />
          <FormField label="Altura (cm)" value={height} onChange={setHeight} isInteger required type="text" />
          <FormField label="Idade" value={age} onChange={setAge} isInteger required type="text" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <FormField label="Sexo" value={gender} onChange={setGender} type="select" options={[{ value: 'male', label: 'Masculino' }, { value: 'female', label: 'Feminino' }]} />
          <FormField label="Atividade" value={activity} onChange={setActivity} type="select" options={[
            { value: 'sedentary', label: 'Sedentário' },
            { value: 'light', label: 'Leve' },
            { value: 'moderate', label: 'Moderado' },
            { value: 'active', label: 'Ativo' },
            { value: 'very_active', label: 'Muito Ativo' }
          ]} />
        </div>
        <div className="flex justify-center mt-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold shadow-accent hover:scale-105 transition-all">Calcular</button>
        </div>
      </div>
      {res && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ResultCard title="Metabolismo Basal" value={`${res.tmb} kcal`} color="purple" />
          <ResultCard title="Calorias Diárias" value={`${res.daily} kcal`} color="indigo" />
        </div>
      )}
    </div>
  );
};

export default TMBCalculator;
